import React from "react";
import { Paper, Typography, Divider, Grid, Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { toTitleCase } from "../../common/services/Utilities";
import { OscrLevelTwoRecord } from "../../interfaces";
import OfficeMapDisplay from "../OfficeMapDisplay";

interface Props {
  resultData: OscrLevelTwoRecord[];
}

const useStyles = makeStyles(() => ({
  card: {
    padding: 15,
    margin: "0 0 15px 0",
  },
}));

export default function OSCRViewBranches({ resultData }: Props) {
  const classes = useStyles();

  const content = resultData.map((data: OscrLevelTwoRecord, index: number) => {
    const officeFields =
      ![240, 230, 260].includes(data.REPORT_TYPE) && data.OFF_NUM !== 0;
    const liquidationFields = ![230, 240, 260, 721].includes(data.REPORT_TYPE);
    return (
      <Grid
        id={`view-branches-card-${data.REPORT_TYPE}-${index}`}
        key={`${index}`}
        item
        md={resultData.length > 1 ? 6 : 12}
        xs={12}
      >
        <Box padding={2}>
          <Paper elevation={4} className={classes.card}>
            <Typography id="office-name" color="primary" variant="h6">
              {toTitleCase(officeFields ? data.OFF_NAME : data.INSTNAME)}
            </Typography>
            <Typography id="office-number">
              Branch Number: {officeFields ? data.OFF_NUM : `Main Office`}
            </Typography>
            <Divider
              style={{
                padding: 0,
                margin: "5px 0",
                borderColor: "#e4eef7",
              }}
            />
            <OfficeMapDisplay
              data={data}
              officeFields={officeFields}
              showDateAcquired={liquidationFields}
            />
          </Paper>
        </Box>
      </Grid>
    );
  });

  return (
    <Grid id="view-branches-container" container>
      {content}
    </Grid>
  );
}
